import { CreateAccountDto } from '../../dto/createaccount/createaccountdto';
import { APIResponse, APIResponseDtoImpl } from '../apiresponse';

export interface CreateAccountResponse extends APIResponse 
{
   getCreateAccountDetails() : CreateAccountDto;
}

export class CreateAccountResponseDtoImpl extends APIResponseDtoImpl implements CreateAccountResponse 
{
    private createAccountDetails: CreateAccountDto;

    getCreateAccountDetails(): CreateAccountDto
    {
        return this.createAccountDetails;
    }
    setCreateAccountDetails(createAccountDetails: CreateAccountDto)
    {
        this.createAccountDetails = createAccountDetails;
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/createaccount/createaccountresponse.tsx